import styled from 'styled-components'

export const Wrapper = styled.div`
  border: 1px solid
    ${(props) => props.theme.mathEssayInput.inputLineWrapperBorderColor};
  padding: 8px;
  overflow: auto;
`
